// For full API documentation, including code examples, visit http://wix.to/94BuAAs



  
$w.onReady(function () {
  var x = null;
  function resolveAfter30Seconds(x) { 
    return new Promise(resolve => {
      x = setTimeout(() => {
        resolve(x);
      }, 30000);
    });
  }  

  async function countDown() {
    
    let countDownDate = new Date("Sep 22, 2018 18:00:00").getTime();
        // Get todays date and time
    let now = new Date().getTime();

        // Find the distance between now an the count down date
    let distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    $w("#dias").text = ("0" + days).slice(-2);
    $w("#horas").text = ("0" + hours).slice(-2);
    $w("#minutos").text = ("0" + minutes).slice(-2);

    // If the count down is finished, write some text 
    if (distance < 0) {
      //clearInterval(x);
      $w("#dias").text = "00";
      $w("#horas").text = "00";
      $w("#minutos").text = "00";
    }    
    await resolveAfter30Seconds();
    clearTimeout(x);
    countDown();
  }

  countDown();
  //let x = setInterval(countDown(), 3000);

  

});